export default "__VITE_ASSET__C06emTeG__"